// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__19Xhx","item":"PaymentsMobile_item__3c6wC","label":"PaymentsMobile_label__Nh50u","amount":"PaymentsMobile_amount__2xAT4"};